export default "__VITE_ASSET__DoSpZq62__"